document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-variant]')) return;
  const root = event.target.closest('[data-product]');
  const option = event.target.selectedOptions[0];
  const button = root.querySelector('[data-add]');
  const coming = button.dataset.coming === 'true';
  const available = option.dataset.available === 'true' && !coming;
  root.querySelector('[data-price]').textContent = option.dataset.price;
  root.querySelector('[data-status]').textContent = coming ? 'Coming soon' : available ? 'Available' : 'Sold out';
  button.disabled = !available;
  const express = root.querySelector('.shopify-payment-button');
  if (express) express.hidden = !available;
  button.textContent = coming ? 'Coming soon' : available ? 'Add to bag' : 'Sold out';
  const url = new URL(window.location.href);
  url.searchParams.set('variant', option.value);
  window.history.replaceState({}, '', url);
  const media = document.getElementById('Media-' + option.dataset.media);
  if (media) media.scrollIntoView({block:'nearest', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') document.querySelectorAll('.mobile-menu[open], .nav-dropdown[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
});
